const BOOLEAN_TRUE = 'true';

export default {
  APP_VERSION: process.env.VUE_APP_VERSION,
  APP_ENV: process.env.VUE_APP_ENV,
  APP_CONTENT_URL: process.env.VUE_APP_CONTENT_URL || process.env.VUE_APP_BASE_URL,
  API_DEBUG: (process.env.VUE_APP_API_DEBUG === BOOLEAN_TRUE),
  LANGUAGES: process.env.VUE_APP_LANGUAGES.split(',').map(entry => String(entry).trim()),
};
